export const impressumData = {
    topLine: "Impressum",
    description:
        "Kunwar Abhinav Aditya\n" +
        "kunwaaar@gmail.com\n" +
        "Berlin, Deutschland (DE)",
};